<template>
  <div class="services-details-bg pb-100">
    <div class="container">
      <div class="services-details-img position-relative mb-4">
        <img title="celebrity marketing agency India, influencer marketing company, ad shoots agency, TV commercial production, digital marketing services, brand endorsements India, social media marketing for brands, Instagram verification services, events and inaugurations management, MyCelebrity by Digitalentio, Bangalore branding agency, celebrity endorsement agency, verified badge services Instagram Facebook, PR article services India, media coverage agency, top branding agency in Bangalore" 
          src="../../assets/images/ser6.jpg"
          alt="services-details"
          class="top-banner-img"
        />
      </div>

      <div class="row">
        <div class="col-lg-8">
          <div class="services-details-content">
            <h2 title="We connect brands with celebrities and influencers for powerful digital campaigns.">PR Articles & Media Coverage</h2>
            <p>Put Your Brand in the Headlines.</p>
            <p>
              At <strong>MyCelebrity</strong>, we craft and distribute impactful PR articles that build trust,
              create awareness, and position your brand as a market leader...
            </p>

            <h3 title="We connect brands with celebrities and influencers for powerful digital campaigns.">What We Offer:</h3>
            <ul>
              <li><strong>Press Release Writing:</strong> Professional, journalistic content crafted to meet editorial standards...</li>
              <li><strong>Publication in Leading Media Houses:</strong> Get featured in platforms like Yahoo News, ANI, Hindustan Times, etc.</li>
              <li><strong>Campaign-Based Media Outreach:</strong> Custom PR for launches, endorsements, etc.</li>
              <li><strong>Founder/CEO Interviews:</strong> Build your personal brand with exclusive features.</li>
              <li><strong>SEO-Optimized Articles:</strong> Boost online visibility and search rankings.</li>
              <li><strong>Regional & Vernacular PR Support:</strong> Publish in South Indian regional languages.</li>
            </ul>

            <h3 title="We connect brands with celebrities and influencers for powerful digital campaigns.">Brands We've Amplified Through PR:</h3>
            <ul>
              <li><strong>Sunpure:</strong> Festival-led press features with celebrity presence</li>
              <li><strong>Ramraj Cotton:</strong> Launch updates and media outreach</li>
              <li><strong>Instapure:</strong> Product launch PR in wellness portals</li>
              <li><strong>Man Matters & Be Bodywise:</strong> D2C brand PR campaigns</li>
              <li><strong>Centuary Mattress, Lulu Mall, Dewar’s, Godesi:</strong> Inauguration and event coverage</li>
            </ul>

            <h3 title="We connect brands with celebrities and influencers for powerful digital campaigns.">Why PR Works:</h3>
            <ul>
              <li>Builds brand credibility and trust</li>
              <li>Enhances visibility in competitive markets</li>
              <li>Drives organic traffic and SEO value</li>
              <li>Increases investor, media, and customer interest</li>
            </ul>
          </div>
        </div>

        <div class="col-lg-4 mt-4 mt-lg-0">
          <ServicesSidebar />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ServicesSidebar from "@/components/ServiceDetails/ServivesSidebar.vue";

export default {
  name: "ServicesDetails",
  components: {
    ServicesSidebar,
  },
};
</script>

<style lang="scss" scoped>
// Light theme (default)
:deep(body):not(.theme-dark) {
  .services-details-bg {
    background-color: #fff;
    color: #000;
  }
}

// Dark theme
:deep(body.theme-dark) {
  .services-details-bg {
    background-color: #111;
    color: #fff;
  }
}

.services-details-bg {
  padding-top: 180px;
  padding-bottom: 100px;
  transition: background-color 0.3s ease, color 0.3s ease;
}

.services-details-img {
  .top-banner-img {
    width: 100%;
    max-width: 100%;
    max-height: 400px;
    border-radius: 20px;
    object-fit: cover;
    display: block;
    margin: 0 auto; // center image
  }
}

.services-details-content {
  padding-top: 20px;

  h2 {
    font-size: 36px;
    margin-bottom: 25px;
  }

  h3 {
    font-size: 20px;
    font-weight: 700;
    margin-bottom: 15px;
  }

  h4 {
    font-size: 18px;
    font-weight: 600;
    margin-top: 25px;
    margin-bottom: 10px;
  }

  ul {
    padding-left: 1.2rem;
    margin-bottom: 20px;

    li {
      margin-bottom: 10px;
    }
  }
}

/* Responsive Design */
@media only screen and (max-width: 767px) {
  .services-details-content {
    h2 {
      font-size: 25px;
      margin-bottom: 15px;
    }
  }

  .top-banner-img {
    max-height: 220px;
    margin: 0 auto;
  }
}

@media only screen and (min-width: 768px) and (max-width: 991px) {
  .services-details-content {
    h2 {
      font-size: 30px;
      margin-bottom: 15px;
    }
  }

  .top-banner-img {
    max-height: 300px;
    margin: 0 auto;
  }
}
</style>
